import React, { Component } from 'react';
import ContributorList from './ContributorList'
import ContributorProfile from './Profile/index'
import SectionEdit from './Profile/SectionEdit'
import { Route, withRouter, BrowserRouter as Router } from 'react-router-dom'
//import Navbar from './Navbar.js'
import NavBarTop from './navbar/index.js'
//import NavbarTop from './NavbarTop'
//import Login from './Login'
import AuditTimeline from './Profile/AuditTimeline'
import Disclaimer from './Disclaimer'
import AccessLog from './AccessLog'
import PrintModule from './PrintModule'
import CustomSections from './PrintModule/CustomSections'
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { LoginCallback, Security, SecureRoute } from "@okta/okta-react";
import { MsalProvider } from "@azure/msal-react";
import EntraContainer from './auth/EntraContainer.js';
//import { CustomNavigationClient } from "./utils/NavigationClient";

// reference: https://developer.okta.com/docs/guides/sign-into-spa-redirect/react/main/
export const oktaAuth = new OktaAuth({
  issuer:
    process.env.REACT_APP_ENV === "development"
      ? "https://gcfund.okta.com/oauth2/ausdbtp5c0dDH8eOo2p7"
      : "https://gcfund.okta.com/oauth2/aus5lsinh9sZiavsf2p7",
  redirectUri: window.location.origin + "/implicit/callback",
  clientId: "0oa3ps3rjlKwuD65w2p7",
  scopes: ["openid", "profile", "email", "groups", "offline_access"],
});

const App = ({ pca }) => {
  return (
    <MsalProvider instance={pca}>
      <div className="App">
        <EntraContainer>
          <div className="container-fluid p-0">
            <div className="row no-gutters">
              <div className="col">
                <NavBarTop />
              </div>
            </div>
            <Route path="/" exact component={ContributorList} />
            <Route
              path="/contributor/:id"
              exact
              component={ContributorProfile}
            />
            <Route
              path="/contributor/:id/audit"
              exact
              component={AuditTimeline}
            />
            <Route
              path="/contributor/:id/section/:sectionid/edit"
              exact
              component={SectionEdit}
            />

            <Route path="/implicit/callback" component={LoginCallback} />
            <Route path="/disclaimer" component={Disclaimer} />
            <Route path="/logs" component={AccessLog} />
            <Route path="/modules/print" exact component={PrintModule} />
            <Route
              path="/modules/print/contributors/:contributors/sections/:sections"
              exact
              component={CustomSections}
            />
            <Route
              path="/modules/print/contributors/:contributors/sections/:sections/custom/:custom"
              exact
              component={CustomSections}
            />
          </div>
        </EntraContainer>
      </div>
    </MsalProvider>
  )
}

export default App;
